const resume = [
  {
    date: "Aug 2020 - Present",
    title: "Fullstack developer",
    desc: `Quomodo is a technology consulting and systems delivery company with operations in the Financial Services, Oil & Gas, Telecommunications etc. 
        Worked on project backend and database using .Net and C#.`,
    company: "Quomodo Systems",
    location: "Abuja, Nigeria.",
    icon: "icon-stack",
    type: "experience",
    link: "https://quomodosystems.com/",
  },
  {
    date: "July 2020 - Present",
    title: "Wordpress developer",
    desc: `I built the company website using WordPress and after building I was
    asked to maintain it which I still do till now (primarily using HTML, CSS,
    BootStrap, JavaScript, and WordPress), Used SEO best practices to optimize Web site for search engine rankings and improved functionality of the company Website, • Posting content created by the content writer on the website and
    keeping track of the users that visited the website per week (primarily
    using Google analytics)`,
    company: "Melhors Investment",
    location: "Lagos, Nigeria.",
    icon: "icon-stack",
    type: "experience",
    link: "melhorsinvestment.com",
  },
  {
    date: "March, 2020 - July, 2020",
    title: "front-end developer - Intern",
    desc: `Each participant is grouped into teams varying between 10-120 people
    depending on the stage. I was part of the frontend developer that worked
    on some projects given to us building projects that cut across sectors like
    health, hotel, etc (primarily using HTML, CSS, BootStrap, JavaScript), • I consumed a lot of API built by the backend guys (primarily using
      JavaScript, Axios, Ajax) given me a bigger understanding of working with
      API and as a team, I also in charge of converting a series of designs designed by series of
      designers getting me better at the Convention.`,
    company: "HNG",
    location: "Remote, Nigeria.",
    icon: "icon-stack",
    type: "experience",
    link: "",
  },
  {
    date: "March 2015 - Dec, 2017",
    title: "Junior Teacher",
    desc: `Worked as a Junior teacher, lecturing Senior Primary (All curriculum) and 
        seldom Junior Secondary students in Biology and Chemistry (Scheduled).`,
    company: "Heritage School",
    location: "Lagos, Nigeria.",
    icon: "icon-stack",
    type: "experience",
    link: "",
  },
  {
    date: "Jan 2020 - Present",
    title: "Computer Science (CS50)",
    desc: `CS50 is Harvard's introduction to the intellectual enterprises of computer science and the art of programming. 
        It's an entry-level course taught by David J. Malan, CS50x teaches students how to think algorithmically and solve problems efficiently.`,
    company: "Harvard",
    location: "Remote",
    icon: "icon-graduation-cap",
    type: "education",
    link:
      "https://online-learning.harvard.edu/course/cs50-introduction-computer-science",
  }
];

export default resume;
